import React from 'react'
import "./question.css"
import { Link } from "react-router-dom"
import TagPills from '../TagPills';
import Moment from 'react-moment';


// IMAGE
import dum from "../../assets/images/dummy_profile.jpg"

function Question({className,questionData}) {
    console.log(questionData)
    return (
        <React.Fragment>
            <div className={`blogsearch bg-white rounded-2xl ${className}`}>
                <div className="blogsearch-wrapper flex">
                    <div className="blogsearch_image--container w-32 h-32 p-1 overflow-hidden wm-flex-15">
                        <img src={questionData.banner_image} alt="blog-image" className="object-cover h-full rounded-md" />
                    </div>
                    <div className="blogsearch__head--container p-1 wm-flex-65">
                        <a href={`https://wisemonkeys.info/questions/${questionData.slug}`} className="text-black text-sm block cursor-pointer">{questionData.question_title}</a>
                        <span className="text-gray-500 text-sm block">{questionData.description}</span>
                        <span className="text-gray-400 text-xs block">asked <Moment unix fromNow>{questionData.created_at}</Moment></span>
                        <div className="blog__tagPills mt-2">
                            {questionData.tags.map((tags,idx) => {
                                return <TagPills key={idx} className="inline-block cursor-pointer pillsBg mr-2 mb-2 rounded text-sm bg-gray-300 px-2 no-underline py-1" tags={tags}/>
                            })}
                        </div>
                    </div>
                    <div className="blogsearch__blog--stats wm-flex-20 pl-3">
                        <div className="blogger_profile--container flex">
                            <img src={dum} alt="prof" className="w-10 h-10 object-cover rounded-full mr-2" />
                            <div className="flex flex-col">
                                <Link to="/" className="text-sm blogger__profileName">{questionData.full_name}</Link>
                                <span className="text-xs text-gray-400">@{questionData.username}</span>
                            </div>
                        </div>
                        <div className="blogger__like--stats flex justify-evenly mt-4">
                            <div className="like__stats flex flex-col cursor-pointer text-center">
                                <span className="">{questionData.stats.like_count}</span>
                                <span className="text-xs text-gray-400">votes</span>
                            </div>
                            <div className="like__stats flex flex-col cursor-pointer text-center">
                                <span className="">{questionData.stats.comment_count}</span>
                                <span className="text-xs text-gray-400">answers</span>
                            </div>
                            <div className="like__stats flex flex-col cursor-pointer text-center">
                                <span className="">0</span>
                                <span className="text-xs text-gray-400">views</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Question
